<template>
  <main class="homepage">
    <section class="controls-section">
      <div class="controls-section-content">
        <app-logo
          class="logo"
          @showHelp="showHelp"
          @hideHelp="hideHelp"
          :isHelpShown="isHelpShown"
          ref="appLogo"
        />
        <filters-section />
      </div>
      <app-footer @showDisclaimer="showDisclaimer" />
    </section>
    <section id="map-section" class="map-section">
      <main-map />
    </section>
    <section class="data-section" id="data-section">
      <data-section />
    </section>
  </main>
</template>

<script>
import MainMap from '@/components/main-map'
import DataSection from '@/components/data-section'
import FiltersSection from '@/components/filters'
import AppLogo from '@/components/logo'
import AppFooter from '@/components/app-footer'

export default {
  name: 'home',
  components: {
    MainMap,
    DataSection,
    FiltersSection,
    AppLogo,
    AppFooter,
  },
  data() {
    return {
      isHelpShown: false,
    }
  },
  methods: {
    showHelp() {
      this.isHelpShown = true
    },
    hideHelp() {
      this.isHelpShown = false
    },
    showDisclaimer() {
      this.showHelp()

      this.$nextTick(() => {
        this.$refs.appLogo.$refs.helpContainer.scrollToDataSourcesDisclaimer()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_mixins';

.homepage {
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  @include desktop {
    flex-direction: row;
    section {
      height: 100vh;
      overflow-y: auto;
    }
  }
}
.logo {
  margin-bottom: 30px;
}
.controls-section {
  display: flex;
  flex-direction: column;
  padding: 0 15px;
  @include desktop {
    width: 240px;
  }
  .controls-section-content {
    flex: 1 1 auto;
  }
}
.data-section {
  @include desktop {
    width: 480px;
  }
}
.map-section {
  height: 500px;
  @include desktop {
    height: 100%;
    flex: 1 1 auto;
  }
}
</style>
